/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Calculated page values.
 * @export
 * @interface PaginationData
 */
export interface PaginationData {
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    pageCount?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    firstPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    lastPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    itemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    itemCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationData
     */
    hasNextPage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PaginationData
     */
    hasPreviousPage?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    firstItemIndex?: number;
    /**
     * 
     * @type {number}
     * @memberof PaginationData
     */
    lastItemIndex?: number;
}

/**
 * Check if a given object implements the PaginationData interface.
 */
export function instanceOfPaginationData(value: object): value is PaginationData {
    return true;
}

export function PaginationDataFromJSON(json: any): PaginationData {
    return PaginationDataFromJSONTyped(json, false);
}

export function PaginationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginationData {
    if (json == null) {
        return json;
    }
    return {
        
        'page': json['page'] == null ? undefined : json['page'],
        'pageCount': json['pageCount'] == null ? undefined : json['pageCount'],
        'firstPage': json['firstPage'] == null ? undefined : json['firstPage'],
        'lastPage': json['lastPage'] == null ? undefined : json['lastPage'],
        'itemsPerPage': json['itemsPerPage'] == null ? undefined : json['itemsPerPage'],
        'itemCount': json['itemCount'] == null ? undefined : json['itemCount'],
        'hasNextPage': json['hasNextPage'] == null ? undefined : json['hasNextPage'],
        'hasPreviousPage': json['hasPreviousPage'] == null ? undefined : json['hasPreviousPage'],
        'firstItemIndex': json['firstItemIndex'] == null ? undefined : json['firstItemIndex'],
        'lastItemIndex': json['lastItemIndex'] == null ? undefined : json['lastItemIndex'],
    };
}

export function PaginationDataToJSON(json: any): PaginationData {
    return PaginationDataToJSONTyped(json, false);
}

export function PaginationDataToJSONTyped(value?: PaginationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'page': value['page'],
        'pageCount': value['pageCount'],
        'firstPage': value['firstPage'],
        'lastPage': value['lastPage'],
        'itemsPerPage': value['itemsPerPage'],
        'itemCount': value['itemCount'],
        'hasNextPage': value['hasNextPage'],
        'hasPreviousPage': value['hasPreviousPage'],
        'firstItemIndex': value['firstItemIndex'],
        'lastItemIndex': value['lastItemIndex'],
    };
}

